import { HttpBackend } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { CfgService } from '../../cfg/cfg.service';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class NoveltyCfg {
  public endpointget: string;
  public endpointpost: string;
}

@Injectable({
  providedIn: 'root'
})
export class NoveltyCfgService extends CfgService<NoveltyCfg> {
  json: any = {
    endpointget: "%{DashboardApiUrl}/novelties",
    endpointpost: "%{DashboardApiUrl}/novelty"
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/novelty.cfg.json`;
  }

  /**
 * Carga las url en el json
 */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
